/**
 * List pages read their filter from the URL only on mount. If we're already on
 * the destination route, changing just the query won't re-apply it — so force a
 * reload in that case.
 */
export const goToListRoute = (href: string) => {
	const normalize = (path: string) => path.replace(/\/$/, '');
	const targetPath = normalize(href.slice(href.indexOf('#')).split('?')[0]);
	const currentPath = normalize(window.location.hash.split('?')[0]);
	window.location.href = href;
	if (currentPath === targetPath) {
		window.location.reload();
	}
};
